import { selectMyTraderaState } from 'tradera-apps/my-tradera/app/state/reducers/my-tradera';
import { selectFiltersState } from 'tradera-apps/my-tradera/app/state/reducers/filters';

import fetch from '../../utils/fetch';
import myTraderaItemsActions from './my-tradera-items';
import myTraderaActions from './my-tradera';
import URLS from '../../constants/urls';
import { actionTypes } from '../action-types/purchase-order';
import {
    initialPayloadPurchaseOrders,
    initialPayloadItems
} from '../../helpers/payloads/purchase-order';
import { toast } from 'react-toastify';
import SimpleToast from 'tradera-components/toasts/simple-toast';
import React from 'react';

const resetPurchaseOrder = () => ({
    type: actionTypes.PURCHASE_ORDER_RESET
});

const runPurchaseOrders = (
    page,
    scrollToInitialScroll = false,
    listViewType,
    waitForBackend = false,
    dontModifyHistory = true
) => async (dispatch, getState) => {
    const endPoint = page.searchUrlNormalView;

    if (!endPoint) {
        return;
    }

    const state = getState();

    const currentMemberId = state.member.memberId;

    dispatch(myTraderaActions.searching(true));
    dispatch(myTraderaActions.error(false));
    dispatch(resetPurchaseOrder());
    dispatch(myTraderaItemsActions.resetMyTraderaItems());

    const search = async () => {
        try {
            const modifiers = selectFiltersState(state).modifiers;

            modifiers.PageNumber = modifiers.paging.page;
            modifiers.PageSize = modifiers.paging.size;

            const data = await fetch(endPoint, {
                body: JSON.stringify(
                    myTraderaItemsActions.changeParamsForBackend(modifiers)
                )
            });

            dispatch({
                type: myTraderaItemsActions.actionTypes.UPDATE_ITEMS,
                payload: {
                    value: {
                        currentMemberId,
                        items: initialPayloadItems(data, page.listType)
                    },
                    page: page.pageName,
                    listViewType,
                    memberMessagingParticipation: selectMyTraderaState(state)
                        .memberMessagingParticipation
                }
            });
            dispatch({
                type: actionTypes.PURCHASE_ORDER_LIST,
                payload: {
                    paging: {
                        from:
                            modifiers.paging.size * (modifiers.paging.page - 1),
                        page: modifiers.paging.page,
                        size: modifiers.paging.size,
                        totalPages: data.totalNumberOfPages,
                        totalItems: data.totalNumberOfPurchaseOrders
                    },
                    purchaseOrders: initialPayloadPurchaseOrders(data, page),
                    statistics: data.statistics
                }
            });

            if (scrollToInitialScroll === true) {
                myTraderaActions.scrollToInitialScroll();
            }

            dispatch(myTraderaActions.error(false));
            return dispatch(myTraderaActions.searching(false));
        } catch (error) {
            dispatch(myTraderaActions.searching(false));
            if (dontModifyHistory === false) {
                myTraderaItemsActions.updateURL(
                    dispatch,
                    page.url,
                    selectFiltersState(state).modifiers
                );
            }
            return myTraderaItemsActions.handleError(dispatch, error);
        }
    };

    // This is a hack to enable delay of searches since sometimes when modifying an item
    // outside of the SPA world, it could take some time for the backend to catch up
    if (waitForBackend === true) {
        setTimeout(search, 3000);
    } else {
        search();
    }
};

const updatePurchaseOrderShipped = (
    purchaseOrderId,
    listViewType,
    transactionIds,
    isShipped
) => async dispatch => {
    dispatch(myTraderaActions.searching(true));
    try {
        dispatch(myTraderaActions.error(false));
        if (isShipped) {
            await fetch(URLS.MARK_SHIPPED, {
                body: JSON.stringify({ ids: transactionIds })
            });
            dispatch(
                myTraderaItemsActions.transactionsMarkAsShippedBySeller(
                    transactionIds,
                    listViewType
                )
            );
        } else {
            await fetch(URLS.UNMARK_SHIPPED, {
                body: JSON.stringify({ ids: transactionIds })
            });
            dispatch(
                myTraderaItemsActions.transactionsUnmarkAsShippedBySeller(
                    transactionIds,
                    listViewType
                )
            );
        }
        dispatch({
            type: actionTypes.PURCHASE_ORDER_SHIPPED,
            payload: {
                isShipped,
                purchaseOrderId
            }
        });
        return dispatch(myTraderaActions.searching(false));
    } catch (error) {
        return myTraderaItemsActions.handleError(dispatch, error);
    }
};

const requestCombinedShippingPrice = (
    purchaseOrderId,
    hasBuyerRequestedCombinedShippingPrice
) => async dispatch => {
    dispatch(myTraderaActions.searching(true));
    try {
        dispatch(myTraderaActions.error(false));

        await fetch(URLS.REQUEST_COMBINED_SHIPPING_PRICE, {
            body: JSON.stringify({
                purchaseOrderId,
                hasRequested: hasBuyerRequestedCombinedShippingPrice
            })
        });

        dispatch({
            type: actionTypes.PURCHASE_ORDER_REQUEST_COMBINED_SHIPPING,
            payload: {
                purchaseOrderId,
                hasBuyerRequestedCombinedShippingPrice
            }
        });

        return dispatch(myTraderaActions.searching(false));
    } catch (error) {
        return myTraderaItemsActions.handleError(dispatch, error);
    }
};

const updatePurchaseOrderPaidByBuyer = (
    purchaseOrderId,
    listViewType,
    isMarkedAsPaidByBuyer
) => async dispatch => {
    dispatch(myTraderaActions.searching(true));
    try {
        dispatch(myTraderaActions.error(false));
        if (isMarkedAsPaidByBuyer) {
            await fetch(URLS.BUYER_MARK_PAID, {
                body: JSON.stringify({ ids: [purchaseOrderId] })
            });
            dispatch(
                myTraderaItemsActions.purchaseOrdersMarkAsPaidByBuyer(
                    [purchaseOrderId],
                    listViewType
                )
            );
        } else {
            await fetch(URLS.BUYER_UNMARK_PAID, {
                body: JSON.stringify({ ids: [purchaseOrderId] })
            });
            dispatch(
                myTraderaItemsActions.purchaseOrdersUnmarkAsPaidByBuyer(
                    [purchaseOrderId],
                    listViewType
                )
            );
        }
        dispatch({
            type: actionTypes.PURCHASE_ORDER_PAID_BY_BUYER,
            payload: {
                isMarkedAsPaidByBuyer,
                purchaseOrderId
            }
        });
        return dispatch(myTraderaActions.searching(false));
    } catch (error) {
        return myTraderaItemsActions.handleError(dispatch, error);
    }
};

const updatePurchaseOrderPaidBySeller = (
    purchaseOrderId,
    listViewType,
    memberMessagingParticipation,
    isPaid
) => async dispatch => {
    dispatch(myTraderaActions.searching(true));
    try {
        dispatch(myTraderaActions.error(false));
        if (isPaid) {
            await fetch(URLS.SELLER_MARK_PAID, {
                body: JSON.stringify({ ids: [purchaseOrderId] })
            });
            dispatch(
                myTraderaItemsActions.purchaseOrdersMarkAsPaidBySeller(
                    [purchaseOrderId],
                    listViewType,
                    memberMessagingParticipation
                )
            );
            toast.success(
                <SimpleToast lokaliseKey="siteWideNotifications_orderMarkedAsPaid" />
            );
        } else {
            await fetch(URLS.SELLER_UNMARK_PAID, {
                body: JSON.stringify({ ids: [purchaseOrderId] })
            });
            dispatch(
                myTraderaItemsActions.purchaseOrdersUnmarkAsPaidBySeller(
                    [purchaseOrderId],
                    listViewType,
                    memberMessagingParticipation
                )
            );
        }
        dispatch({
            type: actionTypes.PURCHASE_ORDER_PAID_BY_SELLER,
            payload: {
                isPaid,
                purchaseOrderId
            }
        });
        return dispatch(myTraderaActions.searching(false));
    } catch (error) {
        return myTraderaItemsActions.handleError(dispatch, error);
    }
};

const deleteShipment = (
    shipmentId,
    purchaseOrderId,
    listViewType
) => async dispatch => {
    dispatch(myTraderaActions.searching(true));
    try {
        await fetch(URLS.DELETE_SHIPMENT, {
            body: JSON.stringify({ shipmentId: shipmentId })
        });
        dispatch(myTraderaActions.error(false));
        dispatch({
            type: actionTypes.PURCHASE_ORDER_DELETE_SHIPMENT,
            payload: {
                purchaseOrderId,
                listViewType
            }
        });
        return dispatch(myTraderaActions.searching(false));
    } catch (error) {
        return myTraderaItemsActions.handleError(dispatch, error);
    }
};

const updateShippingBooked = (
    purchaseOrderId,
    listViewType
) => async dispatch => {
    dispatch(myTraderaActions.searching(true));
    try {
        await fetch(URLS.UNMARK_BOOKED, {
            body: JSON.stringify({ ids: [purchaseOrderId] })
        });
        dispatch(myTraderaActions.error(false));
        dispatch({
            type: actionTypes.PURCHASE_ORDERS_SHIPPING_BOOKED,
            payload: {
                purchaseOrderId,
                listViewType
            }
        });
        dispatch(myTraderaActions.searching(false));
    } catch (error) {
        myTraderaItemsActions.handleError(dispatch, error);
    }
};

const feedbackLeftBySeller = (purchaseOrderId, submittables, listViewType) => {
    return {
        type: actionTypes.PURCHASE_ORDERS_FEEDBACK_LEFT_BY_SELLER,
        payload: {
            submittables,
            purchaseOrderId,
            listViewType
        }
    };
};

const feedbackLeftByBuyer = (purchaseOrderId, submittables, listViewType) => {
    return {
        type: actionTypes.PURCHASE_ORDERS_FEEDBACK_LEFT_BY_BUYER,
        payload: {
            purchaseOrderId,
            submittables,
            listViewType
        }
    };
};

const updatePurchaseOrderHiddenForSeller = (
    purchaseOrderId,
    isHidden,
    listViewType
) => async dispatch => {
    try {
        dispatch(myTraderaActions.searching(true));

        const action = isHidden
            ? myTraderaItemsActions.sellerHideTransaction
            : myTraderaItemsActions.sellerUnhideTransaction;

        dispatch(action([purchaseOrderId], listViewType));
        dispatch({
            type: actionTypes.PURCHASE_ORDER_HIDDEN,
            payload: {
                purchaseOrderId,
                listViewType
            }
        });
        return dispatch(myTraderaActions.searching(false));
    } catch (error) {
        return myTraderaItemsActions.handleError(dispatch, error);
    }
};

const updatePurchaseOrderHiddenForBuyer = (
    purchaseOrderId,
    transactionIds,
    isHidden,
    listViewType
) => async dispatch => {
    try {
        dispatch(myTraderaActions.searching(true));

        const action = isHidden
            ? myTraderaItemsActions.buyerHideTransaction
            : myTraderaItemsActions.buyerUnhideTransaction;

        dispatch(action(transactionIds, listViewType));
        dispatch({
            type: actionTypes.PURCHASE_ORDER_HIDDEN,
            payload: {
                purchaseOrderId,
                listViewType
            }
        });
        return dispatch(myTraderaActions.searching(false));
    } catch (error) {
        return myTraderaItemsActions.handleError(dispatch, error);
    }
};

export default {
    feedbackLeftBySeller,
    feedbackLeftByBuyer,
    updateShippingBooked,
    deleteShipment,
    requestCombinedShippingPrice,
    updatePurchaseOrderShipped,
    updatePurchaseOrderPaidBySeller,
    updatePurchaseOrderPaidByBuyer,
    resetPurchaseOrder,
    runPurchaseOrders,
    updatePurchaseOrderHiddenForSeller,
    updatePurchaseOrderHiddenForBuyer
};
